(function () {
    'use strict';

    /**
     * Module to use Switchery as a directive for angular.
     * @TODO implement Switchery as a service, https://github.com/abpetkov/switchery/pull/11
     */
    angular.module('FormBuilder')
        .directive('fbFieldSwitchery', uiSwitchFunc);

    function uiSwitchFunc ($window, lodash) {
        return {
            restrict: 'AE',
            scope: {
                element: '=',
                model: '=ngModel'
            },
            controller: fbFieldFileDirectiveCtrl,
            controllerAs:'vm',
            bindToController: true,
            link: linkSwitchery,
            template: '<input type="checkbox" class="js-switch" ng-model="vm.model" />'
        };

        function linkSwitchery(scope, elem) {
            var vm = scope.vm;

            var initValue = vm.model || false;
            var options = angular.merge({}, lodash.get(vm, 'element.options', {
                className: 'switchery small',
                color: '#2d82b4'
                //secondaryColor: '#efefef'
            }));
            var switcher = new $window.Switchery(elem.children()[0], options);

            elem.prop('checked', initValue);

            scope.$on('$destroy', function() {
                switcher.destroy();
            });

            elem.on('click', '.switchery-default', function(e) {
                e.preventDefault();
            });

            elem.on('change', 'input[type=checkbox]', function() {
                vm.model = angular.element(this).prop('checked');
                scope.$apply();
            });
        }
    }

    function fbFieldFileDirectiveCtrl() {
        //var vm = this;
    }
})();
